import type {
  GridColDef,
  GridRowParams,
  GridSortModel,
} from '@mui/x-data-grid-pro';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Stack } from '@src/common/components/Stack';
import { tableStyle } from '@src/common/components/tableStyle/TableStyle';
import { theme } from '@src/common/styles/Theme';
import { useCurrentOrder } from '@src/orders/hooks/useCurrentOrder';
import { PermitOrderDrawer } from '@src/permits/permitSearch/PermitOrderDrawer';
import { sortingModeAssembler } from '@src/permits/permitSearch/SortingModeAssembler';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  isLoading: boolean;
  onSortModelChange: (sortModel: GridSortModel) => void;
  sortModel: GridSortModel;
  columns: GridColDef[];
  rows: object[];
}

interface SelectedPermit {
  id: string;
  orderId: string;
}

export const ViewablePermitTable = ({
  isLoading,
  onSortModelChange,
  sortModel,
  columns,
  rows,
}: Props) => {
  const { t } = useTranslation();
  const { removeCurrentOrder } = useCurrentOrder();

  const [selectedPermit, setSelectedPermit] = useState<
    undefined | SelectedPermit
  >();
  const selectPermit = (permit: SelectedPermit) => setSelectedPermit(permit);

  const closeOrder = () => {
    setSelectedPermit(undefined);
    removeCurrentOrder();
  };

  return (
    <Stack flex="1" minHeight="235px" paddingTop={theme.spacing['5']}>
      <DataGridPro
        aria-label={t('permitSearch.table')}
        columns={columns}
        rows={rows}
        onRowClick={(params: GridRowParams) =>
          selectPermit({
            id: params.row.id,
            orderId: params.row.orderId,
          })
        }
        sortingMode={sortingModeAssembler(sortModel)}
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        paginationMode="client"
        className={tableStyle}
        hideFooterRowCount
        hideFooterSelectedRowCount
        disableColumnFilter
        disableColumnMenu
        loading={isLoading}
        localeText={{
          noRowsLabel: t('permitSearch.noResults'),
        }}
      />
      <PermitOrderDrawer permit={selectedPermit} onClose={closeOrder} />
    </Stack>
  );
};
